import { CompVariantsViewItem } from '@wix/thunderbolt-catharsis'
import { CssFeature } from '../cssFeature.types'
import {
	BreakpointsVariantsToCssObjectMap,
	BreakpointsVariantsToLayoutsMap,
} from '../responsiveLayout/responsiveLayout.types'

type LayoutRuntimeCss = {
	layoutRuntime: BreakpointsVariantsToCssObjectMap | null
	layoutVariants: CompVariantsViewItem | null
}

type CompLayouts = { compLayouts: BreakpointsVariantsToLayoutsMap | null }

export type LayoutRuntimeCssFeature = CssFeature<LayoutRuntimeCss, CompLayouts>

export const LayoutRuntimeCSSPrefix = 'layout-runtime'
